module.exports = __webpack_public_path__ + "img/jaguar.70d043be.svg";